import React from 'react';

const Footer = () => (
  <footer className="w-full bg-gray-900 text-white py-8 mt-10">
    <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
      <div className="mb-4 md:mb-0 text-center md:text-left">
        <span className="font-bold text-lg">Dani Job Club</span>
        <p className="text-sm mt-1">Connecting Talent & Opportunity</p>
        <p className="text-xs mt-1">&copy; {new Date().getFullYear()} Dani Job Club. All rights reserved.</p>
      </div>
      <div className="flex flex-col md:flex-row gap-4 items-center">
        <a href="/contact" className="hover:text-yellow-400 transition">Contact</a>
        <a href="/jobs" className="hover:text-yellow-400 transition">Jobs</a>
        <a href="mailto:danijobclub@gmail.com" className="hover:text-yellow-400 transition">danijobclub@gmail.com</a>
        <a href="tel:8943493493" className="hover:text-yellow-400 transition">8943 493 493</a>
      </div>
    </div>
  </footer>
);

export default Footer;
